export const FRAME_PX = 6;

export const EM_BASE_FRAME_PX = 20;
export const EM_TAPE_FRAME_PX = 16;
export const EM_FINISH_FRAME_PX = 8;

export const EM_TAPE_DASH = [30, 30];
// Hazard-tape pattern (diagonal stripes)
export const EM_TAPE_STRIPE_PX = 12;
export const EM_TAPE_GAP_PX = 12;
export const EM_TAPE_ANGLE_DEG = 45;

// Linear-search (LineString) AOI border.
// These mirror the general AOI border weight/dash styling.
export const LINEAR_SEARCH_BORDER_PX = 2;
export const LINEAR_SEARCH_BORDER_DASH = [8, 6];

export const outsideOnlyStrokeWidthPx = (frameWidthPx) => Math.max(1, (frameWidthPx || 1) * 2);

export const EM_YELLOW = '#FDFDAC';
